import { useEffect, useState } from "react";

import { IgPopover, IgSelect } from "@intelligems/ig-theme";
import { Grid, MenuItem, SelectChangeEvent } from "@mui/material";

import { TRAFFIC_CONFIG_QUERY_PARAM_OPTIONS } from "../../utils/constants";

import type { UpdateExpressionNodeQueryType } from "./utils";

interface ConditionKeyProps {
  conditionKey: string;
  onChange: UpdateExpressionNodeQueryType;
  configuredQueryParams?: Set<string>;
  viewOnly?: boolean;
}

export const ConditionKey = ({
  conditionKey,
  onChange,
  configuredQueryParams,
  viewOnly,
}: ConditionKeyProps) => {
  const onOuterChange = (value: string) => {
    onChange(value, "key");
  };
  return (
    <Grid item>
      <CustomUrlParam
        conditionKey={conditionKey}
        configuredQueryParams={configuredQueryParams}
        viewOnly={viewOnly}
        onChange={onOuterChange}
      />
    </Grid>
  );
};

interface CustomUrlParamProps {
  conditionKey: string;
  configuredQueryParams?: Set<string>;
  viewOnly?: boolean;
  onChange: (value: string) => void;
}

const CustomUrlParam = ({
  conditionKey,
  configuredQueryParams,
  viewOnly,
  onChange,
}: CustomUrlParamProps) => {
  const [customQueryKey, setCustomQueryKey] = useState<string>("");
  const options = Array.from(configuredQueryParams?.values() || []).reduce(
    (acc, curr) => {
      acc.add(curr);
      return acc;
    },
    new Set(Object.keys(TRAFFIC_CONFIG_QUERY_PARAM_OPTIONS))
  );

  const onSave = () => {
    onChange(customQueryKey);
    setCustomQueryKey("");
  };

  return (
    <IgSelect
      disabled={viewOnly}
      variant={"outlined"}
      sx={{ width: "160px" }}
      key={`query-param-key`}
      value={conditionKey || ""}
      onChange={(e: SelectChangeEvent<string>) => {
        onChange(e.target.value);
      }}
    >
      <IgPopover
        index={1}
        disabled={viewOnly}
        itemKey={"add-custom"}
        onSaveClick={onSave}
        value={customQueryKey}
        onValueChange={setCustomQueryKey}
        rootComponent={
          <MenuItem
            sx={{
              "&:hover": {
                cursor: "pointer",
              },
            }}
          >
            + Add Custom Parameter
          </MenuItem>
        }
      />
      {[...options].map((qParam) => (
        <MenuItem key={`query-param-key-${qParam}`} value={qParam}>
          {qParam}
        </MenuItem>
      ))}
    </IgSelect>
  );
};
